// extracted by mini-css-extract-plugin
export default {"selectorMaxWidth":"base-generate-ai-subtitles-option-module__selectorMaxWidth--_QEd3"};